var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 79,
    viewBox: "0 0 94 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.8476 5.43293C47.7653 5.29834 47.652 5.18528 47.5171 5.10317C47.0488 4.81794 46.4374 4.96559 46.1516 5.43293L5.11284 72.5351C5.0177 72.6906 4.96738 72.8693 4.96741 73.0516C4.96741 73.5991 5.41224 74.043 5.96088 74.043H88.0384C88.221 74.043 88.4001 73.9928 88.556 73.8979C89.0243 73.6126 89.1723 73.0025 88.8865 72.5352L47.8477 5.43302L47.8476 5.43293ZM52.0876 2.8504L93.1263 69.9525C94.8414 72.7568 93.9537 76.4175 91.1437 78.129C90.2084 78.6986 89.134 79 88.0383 79H5.96078C2.66877 79 0 76.3367 0 73.0515C2.18269e-05 71.9581 0.302002 70.8858 0.872773 69.9525L41.9115 2.8504C43.6266 0.0461529 47.2949 -0.839637 50.1049 0.871819C50.914 1.36463 51.5937 2.04292 52.0876 2.8504ZM46.9996 64.9219C49.1943 64.9219 50.9734 63.1464 50.9734 60.9562C50.9734 58.766 49.1943 56.9905 46.9996 56.9905C44.8048 56.9905 43.0257 58.766 43.0257 60.9562C43.0257 63.1464 44.8048 64.9219 46.9996 64.9219ZM46.9996 22.2908C44.8048 22.2908 43.0257 24.0663 43.0257 26.2565V48.0677C43.0257 50.2579 44.8048 52.0334 46.9996 52.0334C49.1943 52.0334 50.9734 50.2579 50.9734 48.0677V26.2565C50.9734 24.0663 49.1943 22.2908 46.9996 22.2908Z",
    fill: "#E5295F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.cd4c0fc6755591666b8f777a6371467d.svg";
export { ForwardRef as ReactComponent };